// @flow
import {
  RESET_ALERT_FORM_ERROR,
  SET_ALERT_FORM_ERROR,
  SET_ALERT_SECTION,
  CREATE_NEW_USER,
  CREATE_NEW_USER_SUCCESS,
  CREATE_NEW_USER_FAILED,
} from './actionTypes';

export const createNewUser = (
  email: string,
  countryCode: string,
  verticalId: number
): TrovitAction => {
  return { type: CREATE_NEW_USER, payload: { email, countryCode, verticalId } };
};

export const createNewUserSuccess = (): TrovitAction => {
  return { type: CREATE_NEW_USER_SUCCESS };
};

export const createNewUserFailed = (error: string): TrovitAction => {
  return { type: CREATE_NEW_USER_FAILED, payload: error };
};

export const setAlertFormError = (formError: Object): TrovitAction => ({
  type: SET_ALERT_FORM_ERROR,
  payload: formError,
});

export const resetAlertFormError = (): TrovitAction => ({
  type: RESET_ALERT_FORM_ERROR,
});

export const setAlertSection = (section: number): TrovitAction => ({
  type: SET_ALERT_SECTION,
  payload: section,
});



// WEBPACK FOOTER //
// ./app/Alerts/email/actions.js